import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { ProductListing } from './pages/ProductListing';
import { ProductDetail } from './pages/ProductDetail';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { Cart } from './pages/Cart';
import { Account } from './pages/Account';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { ProductManagement } from './pages/admin/ProductManagement';
import { CategoryManagement } from './pages/admin/CategoryManagement';
import { OrdersOverview } from './pages/admin/OrdersOverview';
import { Statistics } from './pages/admin/Statistics';
import { Promotions } from './pages/admin/Promotions';
import { ThemeProvider } from './context/ThemeContext';
import { CartProvider } from './context/CartContext';
import { ProductProvider } from './context/ProductContext';
export function App() {
  return <ThemeProvider data-id="element-0">
      <CartProvider data-id="element-1">
        <ProductProvider data-id="element-2">
          <Router data-id="element-3">
            <div className="flex flex-col min-h-screen" data-id="element-4">
              <Header data-id="element-5" />
              <main className="flex-grow" data-id="element-6">
                <Routes data-id="element-7">
                  <Route path="/" element={<Home data-id="element-9" />} data-id="element-8" />
                  <Route path="/category/:categoryName" element={<ProductListing data-id="element-11" />} data-id="element-10" />
                  <Route path="/product/:productId" element={<ProductDetail data-id="element-13" />} data-id="element-12" />
                  <Route path="/about" element={<About data-id="element-15" />} data-id="element-14" />
                  <Route path="/contact" element={<Contact data-id="element-17" />} data-id="element-16" />
                  <Route path="/cart" element={<Cart data-id="element-19" />} data-id="element-18" />
                  <Route path="/account" element={<Account data-id="element-21" />} data-id="element-20" />
                  <Route path="/admin" element={<AdminDashboard data-id="element-23" />} data-id="element-22" />
                  <Route path="/admin/products" element={<ProductManagement data-id="element-25" />} data-id="element-24" />
                  <Route path="/admin/categories" element={<CategoryManagement data-id="element-27" />} data-id="element-26" />
                  <Route path="/admin/orders" element={<OrdersOverview data-id="element-29" />} data-id="element-28" />
                  <Route path="/admin/statistics" element={<Statistics data-id="element-31" />} data-id="element-30" />
                  <Route path="/admin/promotions" element={<Promotions data-id="element-33" />} data-id="element-32" />
                </Routes>
              </main>
              <Footer data-id="element-34" />
            </div>
          </Router>
        </ProductProvider>
      </CartProvider>
    </ThemeProvider>;
}